import { api } from "../../../utils/api";
import { TOKEN } from "../../../utils/localStorage";
import { getCookie } from "cookies-next";

export const getDefectreportByVesselgraphApi = async (data) => {
  return await api.get(
    `/defect-report/by-vessel/graph?vessel_id=${data?.vessel_id}&startDate=${data?.startDate}&endDate=${data?.endDate}`,
    {
      headers: {
        Authorization: `Bearer ${getCookie(TOKEN)}`,
      },
    }
  );
};

export const getDefectreportAllVesselApi = async (data) => {
  return await api.get(
    `/defect-report/all-vessel/graph?vessel_id=${data?.vessel_id}&startDate=${data?.startDate}&endDate=${data?.endDate}`,
    {
      headers: {
        Authorization: `Bearer ${getCookie(TOKEN)}`,
      },
    }
  );
};

export const getDefectreportAllVesselcategoryApi = async (data) => {
  return await api.get(
    `/defect-report/all-vessel-category/graph?vessel_id=${data?.vessel_id}&startDate=${data?.startDate}&endDate=${data?.endDate}`,
    {
      headers: {
        Authorization: `Bearer ${getCookie(TOKEN)}`,
      },
    }
  );
};

export const getCompletedChecklistCountApi = async (data) => {
  return await api.get(
    `checklist-submission/Completed-list-count?startDate=${data?.startDate}&endDate=${data?.endDate}&vessel_id=${data?.vessel_id}`,
    {
      headers: {
        Authorization: `Bearer ${getCookie(TOKEN)}`,
      },
    }
  );
};

export const getDashboardUnreadDefectListApi = async () => {
  return await api.get(`/defect-report-notification/unread-defects-list`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};
